import { createContext, useContext } from "react";
import type { WpAdmin } from "../api/types";

export type ShellUI = {
  openNewSite: () => void;
  openAddServer: () => void;
  openPalette: () => void;
  openShortcuts: () => void;
  /** Hold a one-time WordPress password until the site page shows it. */
  stashWpAdmin: (siteId: string, wp: WpAdmin) => void;
  takeWpAdmin: (siteId: string) => WpAdmin | null;
};

export const ShellContext = createContext<ShellUI | null>(null);

export function useShell(): ShellUI {
  const ui = useContext(ShellContext);
  if (!ui) throw new Error("useShell must be used inside the app shell");
  return ui;
}
